import range from 'lodash/range';

function BulletStepBar({
  numberOfSteps,
  currentStep,
  label
}: {
  numberOfSteps: number;
  currentStep: number;
  label: string;
}): JSX.Element {
  const steps = range(1, numberOfSteps + 1).map((step) => {
    const status = step === currentStep ? 'current' : step < currentStep ? 'complete' : 'upcoming';
    return { status };
  });

  return (
    <nav className="flex items-center justify-center" aria-label="Progress">
      <p className="text-sm font-medium">
        {label} {steps.findIndex((step) => step.status === 'current') + 1} of {steps.length}
      </p>
      <ol role="list" className="ml-8 flex items-center space-x-5">
        {steps.map((step, stepIdx) => (
          <li key={stepIdx}>
            {step.status === 'complete' ? (
              <div className="block h-2.5 w-2.5 rounded-full bg-blue-500"></div>
            ) : step.status === 'current' ? (
              <div className="relative flex items-center justify-center" aria-current="step">
                <span className="absolute flex h-5 w-5 p-px" aria-hidden="true">
                  <span className="h-full w-full rounded-full bg-indigo-200" />
                </span>
                <span
                  className="relative block h-2.5 w-2.5 rounded-full bg-blue-500"
                  aria-hidden="true"
                />
              </div>
            ) : (
              <div className="block h-2.5 w-2.5 rounded-full bg-gray-200 hover:bg-gray-400"></div>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}

export default BulletStepBar;
